import { ColumnDefinition } from 'src/app/controls/grid/models/column-definition.interface';

export const GRID_COLUMN_DEFINITION: ColumnDefinition[] = [
  {
    id: 'crewNumber',
    transKey: 'Crew number',
    exportAble: true,
  },
  {
    id: 'flag',
    transKey: 'Country',
    type: 'image'
  },
  {
    id: 'driver',
    transKey: 'Driver',
    exportAble: true
  },
  {
    id: 'navigator',
    transKey: 'Navigator',
    exportAble: true
  },
  {
    id: 'additionalCompetitors',
    transKey: 'Additional Competitors',
    type: 'link',
  },
  {
    id: 'accommodationFrom',
    transKey: 'Accommodation From',
    hideAble: true,
    type: 'date'
  },
  {
    id: 'accommodationTo',
    transKey: 'Accommodation To',
    hideAble: true,
    type: 'date'
  },
  {
    id: 'registrationTime',
    transKey: 'Registration time',
    type: 'date',
    dateFormat: 'MMM dd, yyyy HH:mm:ss'
  },
  {
    id: 'noteCompetitor',
    transKey: 'Competitor note',
    type: 'link',
    hideAble: true,
  },
  {
    id: 'noteAuthor',
    transKey: 'Author note',
    type: 'editable',
    hideAble: true,
  },
  {
    id: 'delete',
    transKey: 'Actions',
    hideAble: true,
    type: 'multi',
    textAlign: 'center',
    columns: [
      {
        id: 'edit',
        hideAble: true,
        type: 'button',
        icon: 'edit',
        tooltip: 'Edit registration'
      },
      {
        id: 'logout',
        hideAble: true,
        type: 'button',
        icon: 'logout',
        tooltip: 'LogoutCrewFromCompetition'
      },
    ]
  },
];
